export enum ChatCategory {
  REGULAR = 'regular',
  RENT_PROPOSAL = 'rent_proposal',
}
